/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-card-fixed-height[_ngcontent-%COMP%]{max-height:253px;overflow-y:auto}p[_ngcontent-%COMP%]{word-break:break-word}"];
export { styles as styles };
